(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('ManageAccreditation', [
			'FileUploadFactory',
			'globalConfig',
			'mixpanelFactory',
			ManageAccreditationFunction
		]);

	function ManageAccreditationFunction(
		FileUploadFactory,
		globalConfig,
		mixpanelFactory
	) {
		var manageAccreditation = this;

		(function init() {
			angular.extend(manageAccreditation, globalConfig);

			mixpanelFactory.track('Manage Accreditation Status Shown', { 'Account Type' : 'Individual' });

			manageAccreditation.accreditation = manageAccreditation.serializedForm.accreditation;
			manageAccreditation.accreditationLetter = FileUploadFactory.createStateObj('VERIFICATION_DOCUMENTS');
			manageAccreditation.resetUpload = FileUploadFactory.resetUpload;
			manageAccreditation.uploadFiles = FileUploadFactory.uploadFiles;
		})();

		manageAccreditation.updateAccreditationTypeValidity = function() {
			var accreditationValidity = ( 
				manageAccreditation.serializedForm.gt1MillionNetWorth || 
				manageAccreditation.serializedForm.gt200kSalary || 
				manageAccreditation.serializedForm.gt300kJointIncome || 
				manageAccreditation.serializedForm.businessRepresentative
			);
			manageAccreditation.accreditationStatusForm.accredited.$setTouched('accredited');
			manageAccreditation.accreditationStatusForm.accredited.$setValidity('accredited', accreditationValidity);
		};

		manageAccreditation.clearValidation = function() {
			manageAccreditation.accreditationStatusForm.accredited.$setUntouched('accredited');
			manageAccreditation.accreditationStatusForm.accredited.$setValidity('accredited', true);
		};

		manageAccreditation.updateAccreditation = function() {
			if(manageAccreditation.serializedForm.accredited) {
				manageAccreditation.updateAccreditationTypeValidity();
				manageAccreditation.accreditationStatusForm.accredited.$setUntouched('accredited');
			} else {
				manageAccreditation.clearValidation();
			}
		};

		manageAccreditation.validateQualifications = function() {
			if(manageAccreditation.serializedForm.accredited) {
				manageAccreditation.accreditationStatusForm.accredited.$setTouched('accredited');
			}
		};
	}
})(window.angular);